import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "mt-6" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bids_form = _resolveComponent("bids-form")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_bids_list_filters = _resolveComponent("bids-list-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_ctx.state.is_add_bid)
    ? (_openBlock(), _createBlock(_component_bids_form, {
        key: 0,
        class: "mt-6",
        onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.is_add_bid = false)),
        onAdded: _ctx.onBidAdded
      }, null, 8, ["onAdded"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_page_title, { title: "Список заявок FTL" }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_the_button, {
              class: "primary small",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.is_add_bid = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Создать заявку ")
              ]),
              _: 1
            }),
            _createVNode(_component_the_button, {
              class: "primary text small ml-2",
              onClick: _ctx.exportExcel,
              loading: _ctx.data_state.is_loading
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Скачать в Excel ")
              ]),
              _: 1
            }, 8, ["onClick", "loading"])
          ])
        ]),
        _createVNode(_component_bids_list_filters, {
          class: "mt-6",
          loading: _ctx.data_state.is_loading,
          onSearch: _ctx.applyFilters,
          onResetted: _ctx.resetFilters,
          "is-ftl": ""
        }, null, 8, ["loading", "onSearch", "onResetted"]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.data_state.is_failed && !_ctx.data_state.failure.error_state.is_cancel)
            ? (_openBlock(), _createBlock(_component_failed_fetch, {
                key: 0,
                loading: _ctx.data_state.is_loading,
                text: "При получении списка заявок произошла ошибка",
                "error-message": _ctx.data_state.failure.error_state.message,
                "error-url": _ctx.data_state.failure.error_state.url,
                "error-status": _ctx.data_state.failure.error_state.status,
                onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadBids(_ctx.data_state.pagination.current_page)))
              }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
            : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                key: 1,
                loading: _ctx.data_state.is_loading
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_the_table, {
                    loading: _ctx.data_state.is_loading,
                    columns: _ctx.BidsListFtlColumns,
                    rows: _ctx.data_state.list,
                    "with-limit": "",
                    "pagination-limit": _ctx.filters_state.limit,
                    "pagination-total-items": _ctx.data_state.pagination.total_items,
                    "pagination-current-page": _ctx.data_state.pagination.current_page,
                    "pagination-total-pages": _ctx.data_state.pagination.total_pages,
                    onChangePage: _ctx.loadBids,
                    onChangeLimit: _ctx.onLimitChange
                  }, {
                    td: _withCtx(({ row, column }) => [
                      (column.key === 'status' && row.status)
                        ? (_openBlock(), _createBlock(_component_cheap, {
                            key: 0,
                            class: _normalizeClass(["small", {
                                    yellow: row.status.id === 13,
                                    green: row.status.id === 14,
                                    red: row.status.id === 64,
                                }])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(row.status.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["class"]))
                        : (row.user && column.key === 'user')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(row.user.name), 1)
                            ], 64))
                          : (row.carrier && column.key === 'carrier')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(row.carrier.name), 1)
                              ], 64))
                            : (column.key === 'ftlBidId' && row.ftlBidId)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 3,
                                  class: "text-blue-500",
                                  to: `/ftl/bids/${row.ftlBidId}`,
                                  target: "_blank"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(row.ftlBidId), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : (column.key === 'ftlOrderId' && row.ftlOrderId)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 4,
                                    class: "text-blue-500",
                                    to: `/ftl-orders/${row.ftlOrderId}`,
                                    target: "_blank"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(row.ftlOrderId), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (column.key === 'id' && row.id)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 5,
                                      class: "text-blue-500",
                                      to: `/bids/${row.id}`,
                                      target: "_blank"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(row.id), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                      _createTextVNode(_toDisplayString(row[column.key]), 1)
                                    ], 64))
                    ]),
                    actions: _withCtx(({ row }) => [
                      _createElementVNode("div", _hoisted_5, [
                        (row.status && row.status.id !== 14)
                          ? (_openBlock(), _createBlock(_component_the_button, {
                              key: 0,
                              class: "red small mr-2",
                              hint: "Удалить заявку",
                              onClick: ($event: any) => (_ctx.deleteBid(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        (row.status && row.status.id === 14)
                          ? (_openBlock(), _createBlock(_component_the_button, {
                              key: 1,
                              class: "primary small mr-2",
                              onClick: ($event: any) => (_ctx.downloadContract(row.id)),
                              hint: "Скачать доп. договор"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        (
                                    row.status?.id !== 62 &&
                                    _ctx.havePermission('cabinet.bid-send-to-contract')
                                )
                          ? (_openBlock(), _createBlock(_component_the_button, {
                              key: 2,
                              class: "primary small",
                              onClick: ($event: any) => (_ctx.resendToContract(row.id)),
                              hint: "Переотправить ЗЛ на Договор24"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
                ]),
                _: 1
              }, 8, ["loading"]))
        ])
      ]))
}